export const getElement = (selector) => {
    if (typeof selector === 'string') {
        return document.querySelector(selector)
    }
    // Handle if it's already a DOM element or ref
    if (selector && selector.current) {
        return selector.current
    }
    return selector
}

export const scrollToElement = (element) => {
    if (!element) return

    const rect = element.getBoundingClientRect()
    const isInViewport = (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    )

    if (!isInViewport) {
        element.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center'
        })
    }
}

export const getRect = (element) => {
    if (!element) return { top: 0, left: 0, width: 0, height: 0, bottom: 0, right: 0 }
    return element.getBoundingClientRect()
}

export const waitForElement = (selector, timeout = 3000) => {
    return new Promise((resolve, reject) => {
        const element = getElement(selector)
        if (element) {
            resolve(element)
            return
        }

        const observer = new MutationObserver((mutations, obs) => {
            const element = getElement(selector)
            if (element) {
                obs.disconnect()
                resolve(element)
            }
        })

        observer.observe(document.body, {
            childList: true,
            subtree: true
        })

        setTimeout(() => {
            observer.disconnect()
            reject(new Error(`Element ${selector} not found within ${timeout}ms`))
        }, timeout)
    })
}
